// SPEC-55 · the laterality question in French (see laterality.ts). Tu form,
// French typography: U+202F before ? ! ; : and inside « ». Feminine where
// PT is (« Destra » reads « Droitière »). The founder validates this text
// before prod.

import type { LateralityDictionary } from "./laterality";

export const LATERALITY_FR: LateralityDictionary = {
  pe: {
    question: "Avec quel pied frappes-tu ?",
    label: "Pied dominant",
    options: { "pe-direito": "Pied droit", "pe-esquerdo": "Pied gauche", "os-dois": "Les deux" },
  },
  impulsao: {
    question: "Quelle est ta jambe d’impulsion ?",
    label: "Jambe d’impulsion",
    options: { "perna-direita": "Jambe droite", "perna-esquerda": "Jambe gauche", "nao-sei": "Je ne sais pas" },
  },
  guarda: {
    question: "Quelle est ta garde ?",
    label: "Garde",
    options: { ortodoxa: "Orthodoxe (gauche devant)", canhota: "Fausse garde (droite devant)", troco: "Je change de garde" },
  },
  mao: {
    question: "Avec quelle main lances-tu ou frappes-tu ?",
    label: "Main dominante",
    options: { "mao-direita": "Main droite", "mao-esquerda": "Main gauche", "as-duas": "Les deux" },
  },
  apoio: {
    question: "Quelle est ta jambe d’appui ?",
    label: "Jambe d’appui",
    options: { "perna-direita": "Jambe droite", "perna-esquerda": "Jambe gauche", "as-duas": "Les deux" },
  },
  geral: {
    question: "Tu es droitière ou gauchère ?",
    label: "Latéralité",
    options: { destra: "Droitière", canhota: "Gauchère", ambidestra: "Ambidextre" },
  },
};
